import React, { useEffect, useState } from 'react';
import ComponentRenderer from "../utils/ComponentRenderer";
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useAppId } from "../AppIdContext";

const RegisterScreen = ({ config }) => {
    const appId = useAppId();
    const { state } = useLocation();
    const { item } = state || {};
    const { t } = useTranslation();
    const [registerPlacements, setPlacements] = useState(null);

    useEffect(() => {
        const loadPlacements = async () => {
            try {
                const placements = await import(`../projects/${appId}/placements/register_placements.json`);
                setPlacements(placements.default);
            } catch (error) {
                console.error('Failed to load placements:', error);
            }
        };

        loadPlacements();
    }, [appId]);

    if (!registerPlacements) {
        return <div></div>; // Show a loading state while configuration or data is being loaded
    }

    const data = {

    };

    const renderer = new ComponentRenderer(registerPlacements, data);

    const backgroundPath = `/projects/${appId}/images/login_block_background.png`;

    // Create background style object
    const login_layout_background = config.login_block_background_enable ? {
        background: `url(${backgroundPath}) no-repeat center center fixed`,
        backgroundSize: 'cover',
    } : {};

    return (
        <div className="login_layout"  style={login_layout_background}>
            <div className="login_layout_position_top">{renderer.renderComponents('register_layout_position_top')}</div>
            <div className="login_layout_position_content ">{renderer.renderComponents('register_layout_position_content')}</div>
            <div className="login_layout_position_bottom">{renderer.renderComponents('register_layout_position_bottom')}</div>
        </div>
    );
};

export default RegisterScreen;
